// DateRange.js
import React, { useState, forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { calender_icon } from "../../assets/img";

const normalizeDate = (date) => {
  if (!date) return null;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

const formatDate = (date) => {
  if (!date) return "";
  const d = date.getDate().toString().padStart(2, "0");
  const m = (date.getMonth() + 1).toString().padStart(2, "0");
  const y = date.getFullYear();
  return `${d}-${m}-${y}`;
};

const DateRange0 = ({
  fromDate = "",           // formatted string
  toDate = "",             // formatted string
  setFromDate = () => { },
  setToDate = () => { },
  containerClass = "d-flex ac-jb gap-2 col-md-5",
}) => {

  // internal date objects for datepicker
  const [fromDateObj, setFromDateObj] = useState(null);
  const [toDateObj, setToDateObj] = useState(null);

  React.useEffect(() => {
    if (!fromDate) {
      setFromDateObj(null);
    }
  }, [fromDate]);

  React.useEffect(() => {
    if (!toDate) {
      setToDateObj(null);
    }
  }, [toDate]);


  const [openFrom, setOpenFrom] = useState(false);
  const [openTo, setOpenTo] = useState(false);

  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="d-flex calender-input" onClick={onClick} ref={ref}>

      <input
        type="text"
        value={value || ""}
        placeholder="Select Date"
        readOnly
        className="date-input f3 fs-xs-15 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 placholdercolorchanges2"
      />
      <img src={calender_icon} className="calender-icon me-2" alt="calendar" />
    </div>
  ));

  const disableScroll = () => {
    document.documentElement.style.overflow = "hidden"; // <html>
    document.body.style.overflow = "hidden";
  };

  const enableScroll = () => {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  };

  return (
    <div className={containerClass}>
      {/* From Date */}
      <div className="calender_title1">
        <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
          From Date
        </label>

        <DatePicker
          selected={fromDateObj}
          onChange={(date) => {
            const normalized = normalizeDate(date);
            setFromDateObj(normalized);          // Date object for datepicker
            setFromDate(formatDate(normalized)); // string for your API/state
          }}
          dateFormat="dd-MM-yyyy"
          customInput={<CustomInput value={fromDate} />}
          open={openFrom}
          onClickOutside={() => setOpenFrom(false)}
          onSelect={() => setOpenFrom(false)}
          onInputClick={() => setOpenFrom(true)}
          minDate={new Date()}
          withPortal
          onCalendarOpen={disableScroll}
          onCalendarClose={enableScroll}
        />
      </div>

      {/* To Date */}
      <div className="calender_title1">
        <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
          To Date
        </label>

        <DatePicker
          selected={toDateObj}
          onChange={(date) => {
            const normalized = normalizeDate(date);
            setToDateObj(normalized);           // Date object internally
            setToDate(formatDate(normalized));  // formatted string output
          }}
          dateFormat="dd-MM-yyyy"
          customInput={<CustomInput value={toDate} />}
          open={openTo}
          onClickOutside={() => setOpenTo(false)}
          onSelect={() => setOpenTo(false)}
          onInputClick={() => setOpenTo(true)}
          minDate={new Date()}
          withPortal
          onCalendarOpen={disableScroll}
          onCalendarClose={enableScroll}
        />
      </div>
    </div>
  );
};

export default DateRange0;
